import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';

export function useDashboardDna() {
  const [opts, setOpts] = useState(null);
  const [filters, setFilters] = useState({ year: null, unit_id: 'all', segment: 'all' });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/dashboard-dna/options').then(({ data: o }) => {
      setOpts(o);
      const year = o.years.includes(o.current_year) ? o.current_year : (o.years[o.years.length - 1] || o.current_year);
      setFilters((f) => ({ ...f, year }));
    }).catch(() => setError('Não foi possível carregar os filtros.'));
  }, []);

  const load = useCallback(async (refresh = false) => {
    if (!filters.year) return;
    setLoading(true); setError('');
    try {
      const params = { year: filters.year, refresh };
      if (filters.unit_id !== 'all') params.unit_id = filters.unit_id;
      if (filters.segment !== 'all') params.segment = filters.segment;
      const { data: d } = await api.get('/dashboard-dna', { params });
      setData(d);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Não foi possível carregar o dashboard.');
    } finally { setLoading(false); }
  }, [filters]);

  useEffect(() => { load(false); }, [load]);

  return { opts, filters, setFilters, data, loading, error, refresh: () => load(true) };
}
